export default {
      id: "whatsapp-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/sprite.svg#whatsapp-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./assets/svg/whatsapp.svg
// module id = ./assets/svg/whatsapp.svg
// module chunks = 0